"use client";

import React from "react";
import { useInView } from "react-intersection-observer";

interface SliderProps {
  children: React.ReactNode;
  className?: string;
  gap?: string;
}

const InfiniteSlider = ({
  children,
  className = "",
  gap = "50px",
}: SliderProps) => {
  const { ref, inView } = useInView({
    threshold: 0,
    triggerOnce: false,
  });

  return (
    <div
      ref={ref}
      className={`w-full overflow-hidden flex carousel ${className}`}
      dir="rtl"
    >
      <div
        className={`flex infinite-slider ${
          inView ? "" : "infinite-slider-paused"
        }`}
        style={{ gap: gap, paddingRight: gap }}
      >
        {children}
      </div>
      <div
        className={`flex infinite-slider ${
          inView ? "" : "infinite-slider-paused"
        }`}
        aria-hidden
        style={{ gap: gap, paddingRight: gap }}
      >
        {children}
      </div>
    </div>
  );
};

export default InfiniteSlider;
